import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export const deleteActAPI = async (showId: string, actId: string) => {
  await baseAPI.delete(`/shows/${showId}/acts/${actId}`);
};

export const useDeleteActMutation = () => {
  return useMutation({
    mutationFn: async ({
      showId,
      actId,
    }: {
      showId: string;
      actId: string;
    }) => {
      await deleteActAPI(showId, actId);
    },
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.SHOWS, variables.showId, KEYS.ACTS],
      });
    },
  });
};
